var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    height: "29px",
    width: "29px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Core-/-Question",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C11.589,8 8,11.589 8,16 C8,20.411 11.589,24 16,24 C20.411,24 24,20.411 24,16 C24,11.589 20.411,8 16,8 M16,26 C10.486,26 6,21.514 6,16 C6,10.486 10.486,6 16,6 C21.514,6 26,10.486 26,16 C26,21.514 21.514,26 16,26 M16,22.0601 C15.87,22.0601 15.74,22.0301 15.62,21.9801 C15.49,21.9301 15.39,21.8601 15.29,21.7701 C15.109,21.5801 15,21.3201 15,21.0601 C15,20.7901 15.109,20.5401 15.29,20.3501 C15.39,20.2601 15.49,20.1901 15.62,20.1401 C15.979,19.9801 16.43,20.0701 16.71,20.3501 C16.89,20.5401 17,20.8001 17,21.0601 C17,21.3201 16.89,21.5801 16.71,21.7701 C16.52,21.9501 16.26,22.0601 16,22.0601 M15.8926,18.9893 C15.3396,18.9893 14.8926,18.5413 14.8926,17.9893 L14.8926,17.3153 C14.8926,17.2073 14.9106,17.1023 14.9416,17.0053 C15.1346,16.0213 15.8636,15.3103 16.4646,14.7233 C17.1196,14.0843 17.5166,13.6613 17.5166,13.1753 C17.5166,12.7193 16.9566,12.2343 15.9206,12.2343 C14.8266,12.2343 14.3716,13.0333 14.3666,13.0423 C14.1076,13.5293 13.5016,13.7143 13.0146,13.4563 C12.5266,13.1973 12.3406,12.5913 12.6006,12.1033 C12.9686,11.4093 14.0826,10.2343 15.9206,10.2343 C18.2566,10.2343 19.5166,11.7493 19.5166,13.1753 C19.5166,14.5393 18.5996,15.4343 17.8626,16.1543 C17.3636,16.6413 16.8926,17.1013 16.8926,17.5123 L16.8926,17.9893 C16.8926,18.5413 16.4456,18.9893 15.8926,18.9893",
    id: "Icon",
    fill: "#42484D",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.6c1d77b3.svg";
export { ForwardRef as ReactComponent };